/* wholesale-flow.js
   - intercepts checkout/buy-now clicks for WS-tagged customers and redirects them to /cart
   - handles the ws-place-order-btn on cart page: posts /cart.js payload to your backend webhook
*/

(function(){
  const WEBHOOK_URL = 'https://wholesale-webhook.vercel.app/api/webhook';
  const THANK_YOU_URL = '/pages/wholesale-thank-you';
  const OPTIONAL_SECRET = '3d4-e5f6-7890-rehan-ef0123456789'; 

  function isWholesaleCustomer() {
    try {
      if (!window._customer_tags) return false;
      const tags = String(window._customer_tags).toLowerCase();
      return tags.includes('ws') || tags.includes('wholesale');
    } catch (e) { return false; }
  }

  // 1) Intercept clicks that would send users to checkout; only when WS customer
  (function interceptCheckoutClicks() {
    const SELECTORS = [
      'a[href*="/checkout"]',
      'button[name="checkout"]',
      'button.checkout',
      'button.buy-now',
      '.shopify-payment-button button',
      'button.shopify-payment-button__button',
      'button[data-action="buy-now"]',
      '.buy-now-btn',
      '#buy-now'
    ];
    function onClick(e) {
      if (!isWholesaleCustomer()) return;
      const el = e.target.closest && e.target.closest(SELECTORS.join(','));
      if (!el) return;
      // allow explicit override
      if (el.getAttribute && el.getAttribute('data-ws-allow') === 'true') return;
      e.preventDefault();
      e.stopPropagation();
      // wait briefly for any add-to-cart XHR then go to cart
      setTimeout(function(){ location.href = '/cart'; }, 420);
    }
    document.addEventListener('click', onClick, true);

    // intercept forms that post directly to /checkout
    document.addEventListener('submit', function(e){
      if (!isWholesaleCustomer()) return;
      const form = e.target;
      try {
        const action = (form.getAttribute('action') || '').toLowerCase();
        if (action && action.indexOf('/checkout') !== -1) {
          e.preventDefault();
          location.href = '/cart';
        }
      } catch(e){}
    }, true);
  })();

  // 2) Cart wholesale button handler
  async function handleWSPlaceOrderClick(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    btn.disabled = true;
    const original = btn.innerText;
    btn.innerText = 'Submitting...';

    try {
      // fetch cart
      const cartResp = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartResp.ok) throw new Error('Could not fetch cart');
      const cart = await cartResp.json();

      const payload = { cart: cart, timestamp: new Date().toISOString() };

      // include customer email if available
      if (window._customer_email) payload.customer_email = window._customer_email;

      const headers = { 'Content-Type': 'application/json' };
      if (typeof OPTIONAL_SECRET !== 'undefined' && OPTIONAL_SECRET) {
        headers['x-wh-secret'] = OPTIONAL_SECRET;
      }

      const resp = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      });

      if (!resp.ok) {
        const txt = await resp.text().catch(()=>null);
        throw new Error('Server error: ' + (txt || resp.status));
      }

      // -----------------------------
      // FETCH DRAFT DATA
      // -----------------------------
      const data = await resp.json();
      const draftId = data?.draft_order?.id;
      const draftName = data?.draft_order?.name;

      // -----------------------------
      // NEW FEATURE: CLEAR CART
      // -----------------------------
      try {
        // Method 1: try cart/clear.js
        const clearResp = await fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' }
        });

        if (!clearResp.ok) {
          // fallback: manually remove items
          const cartToClear = await fetch('/cart.js', { credentials: 'same-origin' })
            .then(r => r.json())
            .catch(() => null);

          if (cartToClear && Array.isArray(cartToClear.items)) {
            for (const item of cartToClear.items) {
              await fetch(`/cart/change?line=${item.key || item.variant_id}&quantity=0`, {
                method: 'GET',
                credentials: 'same-origin'
              }).catch(()=>null);
            }
          }
        }
      } catch (errClear) {
        console.warn('Could not clear cart automatically', errClear);
      }

      // -----------------------------
      // FINAL REDIRECT
      // -----------------------------
      window.location.href = `${THANK_YOU_URL}?id=${draftId}&name=${encodeURIComponent(draftName)}`;

    } catch (err) {
      console.error('WS place order error', err);
      alert('Could not create wholesale order. Contact support.');
      btn.disabled = false;
      btn.innerText = original;
    }
  }

  function attachCartButtonListener() {
    const btn = document.getElementById('ws-place-order-btn') || document.getElementById('ws-place-order-btn-cart');
    if (btn && !btn.__ws_bound) {
      btn.__ws_bound = true;
      btn.addEventListener('click', handleWSPlaceOrderClick);
    }
  }

  // Wait for DOM, and observe mutations
  function readyAndObserve() {
    attachCartButtonListener();
    const mo = new MutationObserver(function(){
      attachCartButtonListener();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', readyAndObserve);
  else readyAndObserve();

})();